import { render } from "./flats-crm-topbar-mobile.vue?vue&type=template&id=8edf9b1a"
import script from "./flats-crm-topbar-mobile.vue?vue&type=script&lang=js"
export * from "./flats-crm-topbar-mobile.vue?vue&type=script&lang=js"

import "./flats-crm-topbar-mobile.vue?vue&type=style&index=0&id=8edf9b1a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__